module.exports = __webpack_public_path__ + "media/icons/mastercard-db8c0352.svg";